"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var currency_js_1 = __importDefault(require("currency.js"));
var Cookies = __importStar(require("js-cookie"));
var React = __importStar(require("react"));
var store_credit_1 = require("../../../misc/store-credit");
var tooltip_1 = __importDefault(require("../../../plugins/tooltip"));
var trustPilotWidget_1 = __importDefault(require("../../../sections/trustPilotWidget"));
var format_bundle_variant_title_1 = __importDefault(require("../../../utils/format-bundle-variant-title"));
var format_price_1 = __importDefault(require("../../../utils/format-price"));
var replace_section_variables_1 = __importDefault(require("../../../utils/replace-section-variables"));
var app_1 = require("../app");
var nav_1 = __importDefault(require("../components/nav"));
var page_1 = __importDefault(require("../components/page"));
var useContext = React.useContext, useMemo = React.useMemo, useEffect = React.useEffect;
var renderVariantWithPrice = function (variant, i) { return (React.createElement("div", { className: 'margin-bottom-3 grid-x align-justify h6-7', key: i },
    React.createElement("div", { className: 'small-8 text-gray font-italic' }, (0, format_bundle_variant_title_1.default)(variant.name)),
    React.createElement("div", { className: 'small-2 text-right' },
        React.createElement("span", { className: 'strike text-gray' }, (0, format_price_1.default)(variant.compare_at_price))),
    React.createElement("div", { className: 'small-2 text-right' },
        React.createElement("span", null, (0, format_price_1.default)(variant.price))))); };
exports.default = (function (_a) {
    var _b, _c, _d;
    var autoAddOns = _a.autoAddOns, enableTrustPilotAB = _a.enableTrustPilotAB, settings = _a.settings, shippingIntervalUnitType = _a.shippingIntervalUnitType, shippingIntervalFrequencies = _a.shippingIntervalFrequencies;
    var context = useContext(app_1.AppContext);
    if (!context)
        return null;
    var getAutoAddOnQty = context.getAutoAddOnQty, filteredPromotionalAddOns = context.filteredPromotionalAddOns, selAddOns = context.selAddOns, selChoices = context.selChoices, selDiscountAddOns = context.selDiscountAddOns, selMainVariant = context.selMainVariant, selShippingFrequency = context.selShippingFrequency, handleChangeShippingFrequencyClick = context.handleChangeShippingFrequencyClick, isTestingExpandedMobileLayout = context.isTestingExpandedMobileLayout, handleExpandedMobileLayoutSetup = context.handleExpandedMobileLayoutSetup, skipSteps = context.skipSteps, existingCustomerNewBundleDiscount = context.existingCustomerNewBundleDiscount, existingCustomerNewBundleSavings = context.existingCustomerNewBundleSavings;
    useEffect(function () {
        var _a;
        if (isTestingExpandedMobileLayout) {
            handleExpandedMobileLayoutSetup();
        }
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'diaperBundle__confirm', selectedFrequency: selShippingFrequency });
    }, []);
    var addOnOrigTotals = selAddOns.map(function (addOn) { return Number(addOn.compare_at_price); }).reduce(function (acc, price) { return acc + price; }, 0);
    var discountAddOnTotals = selDiscountAddOns.map(function (addOn) { return Number(addOn.price); }).reduce(function (acc, price) { return acc + price; }, 0);
    var discountAddOnOrigTotals = selDiscountAddOns.map(function (addOn) { return Number(addOn.compare_at_price); }).reduce(function (acc, price) { return acc + price; }, 0);
    // only show the frequency select options here in the confirmation step if we are skipping the select frequency step, and boolean is set by optimize
    var shouldShowFrequencyOptions = (skipSteps === null || skipSteps === void 0 ? void 0 : skipSteps.includes('select-frequency')) && window.OPTIMIZE_SHOW_FREQUENCY_OPTIONS_AT_CONFIRMATION_STEP;
    var totalBundleSavings = addOnOrigTotals + discountAddOnOrigTotals - discountAddOnTotals;
    var isMultisizeBundle = (selMainVariant === null || selMainVariant === void 0 ? void 0 : selMainVariant.option1) === app_1.multisizeVariantOption1;
    // group all the choices by quantity
    var selChoicesGrouped = useMemo(function () {
        return selChoices.reduce(function (arr, choice) {
            var existingIdx = arr.findIndex(function (n) { return n.variant.id === choice.id; });
            if (existingIdx !== -1) {
                arr[existingIdx].quantity++;
            }
            else {
                arr.push({ quantity: 1, variant: choice });
            }
            return arr;
        }, []);
    }, [selChoices]);
    var showNewPricing = !Cookies.get('abPreviousBundlePricing');
    var isLoggedIn = !!((_b = window.customer) === null || _b === void 0 ? void 0 : _b.id);
    var customerQuery = (0, store_credit_1.useCustomerCreditAccount)({ enabled: !!isLoggedIn });
    var customerStoreCreditBalance = ((_d = (_c = customerQuery.data) === null || _c === void 0 ? void 0 : _c.account.creditAccount) === null || _d === void 0 ? void 0 : _d.available_balance) ? Number(customerQuery.data.account.creditAccount.available_balance) : 0;
    return (React.createElement(page_1.default, { renderNav: React.createElement(nav_1.default, { canGoNext: true }) },
        React.createElement("div", { className: 'padding-6 medium-padding-10 large-padding-horizontal-14 large-padding-vertical-8' },
            React.createElement("h1", { className: 'h3' }, settings.header),
            React.createElement("div", { className: 'margin-bottom-6 font-lighter', dangerouslySetInnerHTML: { __html: settings.subheader } }),
            React.createElement("div", { className: 'grid-x margin-bottom-8 grid-margin-x grid-margin-y' },
                React.createElement("div", { className: 'cell medium-12' },
                    selMainVariant && (React.createElement("div", { className: 'margin-bottom-4' },
                        React.createElement("div", { style: { display: 'inline-flex' } },
                            React.createElement("strong", null, (function () {
                                // selMainVariant.name looks like: Training Pants Bundle - S / 5 packs
                                // so we will make it look like: Training Pants Bundle Size S
                                var matches = selMainVariant.name.match(/^(.+?Bundle) \- (.+?)\s/);
                                if (!matches)
                                    return '';
                                return [matches[1], 'Size', matches[2]].join(' ');
                            })())),
                        React.createElement("div", { className: (0, classnames_1.default)({ 'text-soft-purple': showNewPricing }), style: { display: 'inline', float: 'right' } },
                            React.createElement("div", null, (0, format_price_1.default)(selMainVariant.price)),
                            showNewPricing && (React.createElement("div", null,
                                React.createElement("small", null, "per shipment")))),
                        selChoicesGrouped.map(function (_a) {
                            var variant = _a.variant, quantity = _a.quantity;
                            var choiceType = (function () {
                                if (/Training Pant/i.test(variant.name))
                                    return 'Training Pant';
                                if (/Nighttime/i.test(variant.name))
                                    return 'Nighttime';
                                return 'Daytime';
                            })();
                            // the price is a string like '1.00' via graphql
                            var price = typeof variant.price === 'string' ? Number(variant.price) * 100 : variant.price;
                            return (React.createElement("div", { className: 'grid-x align-middle margin-bottom-2', key: variant.id },
                                variant.featured_image && React.createElement("img", { className: 'margin-right-2 radius', src: variant.featured_image.src, style: { height: 30, width: 30 } }),
                                React.createElement("span", { className: 'cell auto h6-7 text-gray' },
                                    React.createElement("span", null,
                                        quantity,
                                        " x "),
                                    React.createElement("span", { className: 'font-bold' }, (function () {
                                        if (choiceType === 'Nighttime')
                                            return 'Nighttime: ';
                                        if (choiceType === 'Training Pant')
                                            return 'Training Pants: ';
                                        return 'Daytime: ';
                                    })()),
                                    React.createElement("span", { className: 'font-italic' },
                                        variant.option2,
                                        isMultisizeBundle ? " (Size ".concat(variant.option1, ")") : '')),
                                price > 0 && React.createElement("span", { className: 'cell small-2 text-right h6-7' }, (0, format_price_1.default)(price * quantity))));
                        }))), autoAddOns === null || autoAddOns === void 0 ? void 0 :
                    autoAddOns.map(function (_a, i) {
                        var _b = __read(_a, 2), product = _b[0], variant = _b[1];
                        var quantity = getAutoAddOnQty(variant);
                        if (!quantity) {
                            return;
                        }
                        return (React.createElement("div", { className: 'margin-bottom-4', key: i },
                            React.createElement("div", { style: { display: 'inline-flex' } },
                                React.createElement("strong", null,
                                    quantity,
                                    " x ",
                                    (0, format_bundle_variant_title_1.default)(product.title)))));
                    }),
                    filteredPromotionalAddOns &&
                        filteredPromotionalAddOns.map(function (product, i) {
                            var variant = product.variants[0];
                            var freeConditions = /\((.*?)\)/.exec(product.title);
                            return (React.createElement("div", { className: 'margin-bottom-4', key: i },
                                React.createElement("div", { className: 'display-inline font-bold' },
                                    "1 x ",
                                    product.title.split('(')[0],
                                    " ",
                                    React.createElement("span", { className: 'text-wisteria' },
                                        "(",
                                        freeConditions ? freeConditions[1] : '',
                                        ")")),
                                variant.compare_at_price && React.createElement("span", { className: 'strike text-gray padding-left-2' }, (0, format_price_1.default)(variant.compare_at_price)),
                                React.createElement("span", { className: 'padding-left-2' },
                                    "+",
                                    (0, format_price_1.default)(variant.price))));
                        }),
                    !!selAddOns.length && (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("strong", null, "Freebie")),
                        selAddOns.map(renderVariantWithPrice)))),
                !!selDiscountAddOns.length && (React.createElement("div", { className: 'cell medium-12' },
                    React.createElement("div", null,
                        React.createElement("strong", null, "Extras")),
                    selDiscountAddOns.length > 0 ? selDiscountAddOns.map(renderVariantWithPrice) : React.createElement("small", null, "(None)")))),
            settings.showTotalSavings && totalBundleSavings > 0 && (React.createElement("div", { className: 'grid-x float-right', style: { color: '#a05eb5' } },
                "Total Bundle Savings ",
                React.createElement("span", { className: 'padding-left-12' },
                    "+",
                    (0, format_price_1.default)(totalBundleSavings)))),
            shouldShowFrequencyOptions && (React.createElement("div", null,
                React.createElement("strong", null, "Bundle Frequency"),
                React.createElement("label", null,
                    React.createElement("select", { name: 'frequency', value: selShippingFrequency === null || selShippingFrequency === void 0 ? void 0 : selShippingFrequency.toString(), onChange: function (e) {
                            var optionAsNum = Number(e.target.value);
                            handleChangeShippingFrequencyClick(optionAsNum)();
                        } }, shippingIntervalFrequencies.map(function (num) { return (React.createElement("option", { key: num, value: num },
                        num,
                        " ",
                        shippingIntervalUnitType.toLowerCase())); }))))),
            existingCustomerNewBundleSavings && existingCustomerNewBundleDiscount && (React.createElement("div", { className: 'grid-x' },
                React.createElement("div", { className: 'small-6' },
                    "Discount savings ",
                    existingCustomerNewBundleDiscount.discount_type === 'percentage' && "".concat(existingCustomerNewBundleDiscount.value, "%")),
                React.createElement("div", { className: 'small-6 text-right text-wisteria' },
                    "-",
                    (0, format_price_1.default)(existingCustomerNewBundleSavings)))),
            (selShippingFrequency || customerStoreCreditBalance > 0) && (React.createElement("div", { className: 'text-center h6-7 padding-horizontal-4 padding-top-12' },
                customerStoreCreditBalance > 0 && (React.createElement("div", null,
                    "Your Store Credit will automatically apply.",
                    React.createElement(tooltip_1.default, { button: React.createElement("i", { className: 'ss-info padding-left-1 h6-7', style: { verticalAlign: 'middle', lineHeight: '100%' } }) },
                        React.createElement("div", { className: 'padding-3 h6-7' },
                            "You have ",
                            React.createElement("span", { className: 'font-bold' },
                                "$",
                                (0, currency_js_1.default)(customerStoreCreditBalance).toString()),
                            " in Store Credit available.")))),
                selShippingFrequency && (React.createElement("p", { style: { margin: 0 } }, (0, replace_section_variables_1.default)(settings.shippingBlurb, { interval: "".concat(selShippingFrequency, " ").concat(shippingIntervalUnitType.toLowerCase()) }))))),
            enableTrustPilotAB ? React.createElement(trustPilotWidget_1.default, null) : React.createElement("span", null))));
});
